import { cn } from '@/client/utils';
import NumberFlow, { NumberFlowGroup } from '@number-flow/react';

type Props = {
  seconds: number;
  className?: string;
};
export const Countdown = ({ seconds, className }: Props) => {
  const hh = Math.floor(seconds / 3600);
  const mm = Math.floor((seconds % 3600) / 60);
  const ss = seconds % 60;
  return (
    <NumberFlowGroup>
      <span style={{ fontVariantNumeric: 'tabular-nums' }} className={cn('inline-flex items-baseline', className)}>
        <NumberFlow trend={-1} value={hh} format={{ minimumIntegerDigits: 2 }} />
        <NumberFlow prefix=":" trend={-1} value={mm} digits={{ 1: { max: 5 } }} format={{ minimumIntegerDigits: 2 }} />
        <NumberFlow prefix=":" trend={-1} value={ss} digits={{ 1: { max: 5 } }} format={{ minimumIntegerDigits: 2 }} />
      </span>
    </NumberFlowGroup>
  );
};
